// deps
import React, { ReactElement, memo, useCallback } from "react";

// internal-deps
import { ADDRESS_LIST_TEST_IDS } from "@swiggy-private/cart-test-ids";

// styles
import styles from "./AddressListLoaderHalfCard.scss";
import { HalfCard } from "@swiggy-private/dls-web-core/dist/components/HalfCard";

const AddressListLoaderHalfCardContent = (): ReactElement => {
    return (
        <div data-testid={ADDRESS_LIST_TEST_IDS.HALF_CARD_LOADER}>
            <div className={styles.containerTitlePh} />
            <div className={styles.containerBodyPh}>
                <div className={styles.containerBodyPhFirst}>
                    <div className={styles.containerBodyPhFirstIconPh} />
                    <div className={styles.containerBodyPhFirstMainPh} />
                </div>
                <div className={styles.containerBodyPhSecond} />
            </div>
            <div className={styles.containerFooterPh} />
        </div>
    );
};

function AddressListLoaderHalfCard(): ReactElement {
    const _onClose = useCallback((): void => void 0, []);

    return (
        <HalfCard isOpen hideCloseIcon onClose={_onClose}>
            <AddressListLoaderHalfCardContent />
        </HalfCard>
    );
}

export default memo(AddressListLoaderHalfCard);
